import type { CoreLogger } from '@elara/core/logger';

import type { AppFlowsContainer } from '#flows.js';
import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';
import { ModelToClientPipeline } from '@elara/domain/processing/pipelines';

import { createChatMessageModel } from '#models/ChatMessageModel.js';
import { createClientChatModel } from '#models/ChatModel.js';
import { createResourceMetadataModel } from '#models/ResourceMetadataModel.js';
import { createToolCallModel } from '#models/ToolCallModel.js';

export function createChatsContainer(flows: AppFlowsContainer, firestore: FirestoreContainer, logger: CoreLogger) {
  const $chats = createContainer('chats')
    .providedLazy('modelToClientPipeline', () => new ModelToClientPipeline(logger))
    .providedLazy('ClientToolCall', () => createToolCallModel(firestore))
    .providedLazy('ClientResourceMetadata', () => createResourceMetadataModel(firestore))
    .dependent('ClientChatMessage', ['modelToClientPipeline'], ({ modelToClientPipeline }) =>
      createChatMessageModel(firestore, modelToClientPipeline),
    )
    .dependent('ClientChat', ['ClientChatMessage'], ({ ClientChatMessage }) =>
      createClientChatModel(flows, firestore, ClientChatMessage),
    );
  return $chats;
}

export type $ChatsContainer = ReturnType<typeof createChatsContainer>;
export type ChatsContainer = $ChatsContainer['use'];
